









































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountCreateFundRequestModel from '@/models/bankaccounts/BankAccountCreateFundRequestModel';
import BankAccountFundResponseModel from '../../models/bankaccounts/BankAccountFundResponseModel';

@Component({
        name: 'BankAccountCreateFund',
    },
)
export default class BankAccountCreateFund extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public fundName: string = '';
    public notes: string = '';
    public authorized: boolean = false;

    public fundNameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A fund name is required.';
        }
        else
        {
            const funds: BankAccountFundResponseModel[] = this.$store.state.selectedBankAccount.funds;

            const fundIdx: number = funds.findIndex((x: BankAccountFundResponseModel) => x.fundName.toUpperCase() === value.toUpperCase());

            if ( fundIdx > -1 )
            {
                return 'A fund with the same name already exists.';
            }
        }

        return true;
    }

    public created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.CREATE_FUND )
        {
            this.authorized = true;
        }
    }

    public async saveClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new BankAccountCreateFundRequestModel();
                request.fundName = this.fundName;
                request.notes = this.notes;

                const api = new BankAccountsApi();
                const response = await api.createFundAsync(this.bankAccountId, this.$store.state.member.jwt, request);

                await this.$router.push({name: 'bankaccountdashboard', params: { bankAccountId: this.bankAccountId.toString(10)}});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.createFundForm;

        return form.validate();
    }

}

